// Core SDK exports
export { PostackCMS } from './client';
export type { 
  PostackCMSConfig, 
  PostackCMSOptions,
  Post,
  PostsResponse,
  GetPostsOptions
} from './client';

// React components
export { BlogList, FeaturedPosts } from './components';
export type { 
  BlogListOptions, 
  BlogListProps,
  FeaturedPostsProps 
} from './components';

// Default export for convenience
import { PostackCMS } from './client';
export default PostackCMS; 